// machineNames.js — Display-Mapping Prinance → BDE (Req #9)
//
// Read-only renaming so users see the new names everywhere even before the
// machines master-table (#40) lands. Falls back to the original Prinance name.

const DISPLAY_MAP = {
  // Druck-Produktion
  'CD102-K1': '102er Offs.',
  'CD102':    '102er Offs.',
  'CD75-5T':  '75er Offs.',
  'CD754-5T': '75er Offs.',
  'CD75':     '75er Offs.',
  'LINO_CV':  'Digital A',
  'LINO':     'Digital A',
  'Digital':  'Digital B',
  'Versafire3':'Digital C',
  'Versafire':'Digital C',

  'Digital X': 'Digital X',  // #9 Handauswahl-Lane (NICHT Extern — siehe #11)

  // Weiterverarbeitung
  'STILO':       'Stitch-Liner HX',  // also Stitch-Liner D — manual radio
  'SAMMELH':     'Stitch-Liner HX',
  'Sammelh.':    'Stitch-Liner HX',
  'Klebebinder': 'Binder',
  'Klebebinder extern': 'Binder ext',
  'Falz 79': 'Fold 78',
  'Falz 55': 'Fold 55',
  'FALZ':    'Fold 78',
  'Bubi extern': 'WV ex',

  // Synonyms used in test data + extern
  'Extern':    'Extern (X)',
  'X':         'Extern (X)'
}

// Runtime registry populated from /api/v1/machines (Req #40). When present it
// takes precedence over the static DISPLAY_MAP, so admin renames take effect
// without a redeploy. Static map stays as the offline fallback.
let REGISTRY = null     // { lowercased alias|code|display -> display_name }
let MACHINE_LIST = []   // full list for dropdowns
let ACTIVE = {}         // { lowercased alias|code|display -> active? } from the `active` flag
let CATEGORY = {}       // { lowercased alias|code|display -> 'druck'|'wv'|'ctp'|… }

export function setMachineRegistry(machines) {
  MACHINE_LIST = Array.isArray(machines) ? machines : []
  const map = {}
  const active = {}
  const category = {}
  for (const m of MACHINE_LIST) {
    const isActive = m.active !== false   // default to active if the flag is absent
    const keys = [m.display_name, m.code, ...(m.aliases || [])].filter(Boolean)
    for (const k of keys) {
      const lk = String(k).toLowerCase()
      if (m.display_name) map[lk] = m.display_name
      // OR-accumulate: a name shared by several machines counts as active
      // as long as at least one of them is still active.
      active[lk] = active[lk] || isActive
      if (m.category) category[lk] = m.category
    }
  }
  REGISTRY = map
  ACTIVE = active
  CATEGORY = category
}

// Category ('druck' | 'wv' | 'ctp' | …) of a raw machine string, or null when
// the registry does not know it. Callers must treat null as "no basis for a
// comparison" rather than guessing a default.
export function machineCategory(raw) {
  if (!raw) return null
  return CATEGORY[String(raw).toLowerCase().trim()] || null
}

export function getMachineList() {
  return MACHINE_LIST
}

// Whether a Kap.Pl. lane (with its broad alias list) should be shown. A lane is
// hidden only when EVERY backend machine it maps to is unchecked ("Aktiv" off).
// If none of the aliases match a known machine (e.g. the registry hasn't loaded
// yet, or offline fallback), the lane defaults to visible.
export function laneIsActive(aliases) {
  let known = false
  let anyActive = false
  for (const a of (aliases || [])) {
    const lk = String(a).toLowerCase().trim()
    if (lk in ACTIVE) {
      known = true
      if (ACTIVE[lk]) anyActive = true
    }
  }
  return known ? anyActive : true
}

export function displayMachineName(raw) {
  if (!raw) return ''
  const key = String(raw).trim()
  if (REGISTRY && REGISTRY[key.toLowerCase()]) return REGISTRY[key.toLowerCase()]
  if (DISPLAY_MAP[key]) return DISPLAY_MAP[key]
  // case-insensitive fallback against the static map
  const hit = Object.keys(DISPLAY_MAP).find(k => k.toLowerCase() === key.toLowerCase())
  return hit ? DISPLAY_MAP[hit] : raw
}

// The Komplett-Extern lane (Req #11). Selecting it marks the whole job as
// outsourced; OrderFlags then draws a red ring around the PK/SB dot.
// Kept in sync with Machine::EXTERN_DISPLAY_NAME and lib/tasks/machines.rake.
export const EXTERN_MACHINE = 'Extern (X)'

// Whether a machine maps to a true "Extern" lane (red ring in OrderFlags)
export function isExternMachine(raw) {
  const d = displayMachineName(raw).toLowerCase()
  return d.includes('extern')
}
